import intlTelInput from 'intl-tel-input';
const input = document.querySelector("#phone");
const output = document.querySelector("#output");
// let selectedCountryData

export let number;

const iti = intlTelInput(input, {
  nationalMode: false,
  // nationalMode: true,
  // dropdownContainer: customDropdown,
  // autoPlaceholder: "polite",
  preferredCountries: ["ru", "by"],
  placeholderNumberType: "MOBILE",
  formatOnDisplay: true,
  // customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
  //   return "e.g. " + selectedCountryPlaceholder;
  //   // return "e.g. " + JSON.stringify(selectedCountryData);
  // },
  autoInsertDialCode: true,
  // separateDialCode: true,
  utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
});

// console.dir(iti)
const handleChange = () => {
  // debugger
  let text;
  // console.log(input.value)
  if (input.value) {
    text = iti.isValidNumber()
      ? "Valid number! Full international format: " + iti.getNumber()
      : "Invalid number - please try again";
    // number = iti.getNumber();
      console.log(text)
  } else {
    text = "Please enter a valid number below";
  }
  const textNode = document.createTextNode(text);
  // output.innerHTML = "";
  // output.appendChild(textNode);
  console.log(iti.getSelectedCountryData())
};

// listen to "keyup", but also "change" to update when the user selects a country
input.addEventListener('change', handleChange);
input.addEventListener('keyup', handleChange);
input.addEventListener('open:countrydropdown', () => {
  console.log(5)
});
input.addEventListener('close:countrydropdown', () => {
  console.log(6)
});



const dropdownParent = document.querySelector(".iti--allow-dropdown");
const dropdown = dropdownParent.querySelector(".iti__country-list");

new ResizeObserver(() => dropdown.style.width = dropdownParent.offsetWidth + 'px').observe(dropdownParent);
